import { render } from "./BarcodeTable.vue?vue&type=template&id=b021a48c"
import script from "./BarcodeTable.vue?vue&type=script&lang=js"
export * from "./BarcodeTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__